import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid, MenuItem, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ShipmentContainerInfo } from "../../../../../models/shipments";
import { Select } from "../../../../Form";
import { Color } from "../../../../Form/Button";
import { ActionButtonProps } from "../../../ActionButtons";
import Modal from "../../../Modal";
import useStyles from "./styles";

export interface ContainerModalHandles {
  open: (ssccs?: string[], container?: string) => void;
  close: () => void;
}
interface ContainerModalProps {
  closeModal?: () => void;
  onSubmit: (container?: string, ssccs?: string[]) => void;
  containers?: ShipmentContainerInfo[];
}

const ContainerModal: ForwardRefRenderFunction<ContainerModalHandles, ContainerModalProps> = (
  props,
  ref
) => {
  const classes = useStyles();
  const { closeModal, onSubmit, containers } = props;
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [containerName, setContainerName] = useState<string>("");
  const [ssccs, setSsccs] = useState<string[]>();
  const open = useCallback((ssccs?: string[], container?: string) => {
    setOpenModal(true);
    setSsccs(ssccs);
    if (container) setContainerName(container);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setContainerName("");
    setSsccs([]);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };

  const onSave = () => {
    onSubmit(containerName, ssccs);
    onClose();
  };

  const actionButtonProps: ActionButtonProps = {
    textSave: translate("choose"),
    textCancel: translate("cancel"),
    customColorCancel: Color.CANCEL,
    customColorSave: Color.SUCCESS,
    onSave,
    onCancel: onClose,
  };

  return (
    <Modal
      title={translate("chooseAContainerToAddTheSsccInto")}
      open={openModal}
      handleClose={onClose}
      className={classes.paper}
      showActionButtons
      actionButtonProps={actionButtonProps}
    >
      <Grid container direction="column">
        <Grid item xs={12}>
          <Select
            name="chooseReport"
            value={containerName}
            onChange={(event: SelectChangeEvent<any>) => setContainerName(event.target.value)}
            displayEmpty
            placeholder={translate("selectAnOption")}
            disabled={!containers?.length}
          >
            {containers &&
              containers?.map((container, index) => (
                <MenuItem key={`${index}-container`} value={container?.container}>
                  {`${translate("container")} #${container?.container || ""}`}
                </MenuItem>
              ))}
          </Select>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default forwardRef(ContainerModal);
